import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { toastShow } from "../../../../Base/Services/ToastService";

import { chageEstadoAspirantes, descargarFoto, eliminarFotos, getAspirantes, getFoto, mostrarFotos } from "../../../../API/RRHH/Maestros/MaestrosRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

import CandidatosCRUD from "./CandidatosCRUD";
import ImagenCRUD from "../../../../Base/Components/Dialog/ImagenCRUD";
import { downloadFile, uploadHandlerFotoCandidato } from "../../../../Base/Services/ArchivosService";

const CandidatosScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const fileUpload = useRef(null);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogFoto, setShowDialogFoto] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [eliminarFoto, setEliminarFoto ] = useState([]);
  const [showDialogEliminar, setShowDialogEliminar] = useState(false);

  const getInfo = async () => {
    setLoading(true);

    const dataTempo = await getAspirantes();
    setData(dataTempo);

    const estadosTempo = await getEstadosCategory("Aspirantes");
    setEstados(estadosTempo);

    setLoading(false);
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdAspirante: item.IdAspirante,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdAspirante: data.IdAspirante,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Candidatos ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdAspirantes = changes.map((item) => item.IdAspirante);
                cambiarEstado(e.value.IdStatus, IdAspirantes.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdAspirantes) => {
    const result = await chageEstadoAspirantes({ IdStatus, IdAspirantes });
    toastShow( toast, "success", "Actualizado", "Estado cambiado exitosamente" );
    setSelected([]);
  };

  const columns = [
    {
      field: "IdAspirante",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Nombres",
      headerEn: "Names",
      header: "Nombres",
      frozen: 1,
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Apellidos",
      headerEn: "Last Name",
      header: "Apellidos",
      frozen: 1,
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: (rowData) => {
        if(rowData.data?.IdAspirante){
          return true
        }else{
          return false
        }
      } 
    },
    {
      field: "Identidad",
      header: "Identidad",
      headerEn: "Identity",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Telefono",
      header: "Teléfono",
      headerEn: "Phone",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Correo",
      header: "Correo",
      headerEn: "Email",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Genero",
      header: "Género",
      headerEn: "Género",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "FechaNacimiento",
      header: "FechaNacimiento",
      headerEn: "FechaNacimiento",
      className: "Xsmall",
      Format: 'DateTime',
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Edad",
      header: "Edad (Años)",
      headerEn: "Age (Years)",
      className: "Xsmall",
      Format: 'Currency',
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "UltimoTrabajo",
      header: "Ultimo Trabajo",
      headerEn: "Ultimo Trabajo",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "UltimoTrabajo",
      header: "Ultimo Trabajo",
      headerEn: "Ultimo Trabajo",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Idiomas",
      header: "Idiomas",
      headerEn: "Languajes",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Experiencia",
      header: "Experiencia",
      headerEn: "Expirience",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdPosicion > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "AniosExperiencia",
      header: "Años de Experiencia",
      headerEn: "Años de Experiencia",
      className: "small",
      Format: 'Currency',
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "AspiracionSalarial",
      header: "Aspiracion Salarial",
      headerEn: "Aspiracion Salarial",
      className: "small",
      Sumary: 'sum',
      Format: 'Currency',
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Minimo",
      header: "Salario Mínimo",
      headerEn: "Salario Mínimo",
      className: "Xsmall",
      Format: 'Checkbox',
    },
    {
      field: "HorasExtra",
      header: "Horas Extra",
      headerEn: "Horas Extra",
      className: "Xsmall",
      Format: 'Checkbox',
    },
    {
      field: "Direccion",
      header: "Dirección",
      headerEn: "Address",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Comentarios",
      header: "Comentarios",
      headerEn: "Comments",
      className: "Xlarge",
      flex: 1,
      minWidth: 300,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdAspirante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creado",
      headerEn: "Date Create",
      Format: "DateTime",
      className: "medium",
    },
    {
      field: "UserNameCreate",
      header: "User Create",
      headerEn: "User Create",
      className: "medium",
    },
    {
      field: "IdAspirante",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdAspirante > 0) {
              setShowDialog(true);
              setSelected([rowData]);
            }
          },
        },
        {
          icon: "pi pi-user",
          tooltip: "Agregar Foto",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdAspirante > 0) {
              setShowDialogFoto(true);
              setSelected([rowData]);
            }
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal : () => {}
  };

  //IMAGENES
  const subirArchivo = async (e) => {
    setLoading(true);
    const archivosGuardados = await getArchivos();
    if (archivosGuardados?.length + e.files.length > 1) {
      if (toast) {
        toastShow(toast, "error", 'Error',"Solo se permite subir 1 foto.");
      }
      return;
    }
    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: selected[0]?.IdAspirante,
      },
      {
        name: "Codigo",
        type: "text",
        value: selected[0]?.NombreCompleto,
      },
    ];

    uploadHandlerFotoCandidato({ e, inputs, toast, ref: fileUpload, getArchivos });
    getArchivos();
    setLoading(false);
  };

  const getArchivos = async () => {
    setLoading(true);
    const resp = await getFoto(selected[0]?.NombreCompleto);
    setListadoArchivos(resp);

    if (resp?.length > 0) {
      let n = await Promise.all(
        resp.map(async (e) => {
          try {
            const a = await mostrarFotos(selected[0]?.NombreCompleto);
            return a;
          } catch (e) {
            return e;
          }
        })
      );
      setImagenes({ NombreCompleto: selected[0]?.NombreCompleto , img: n });
    } else {
      setImagenes([]);
    }
    setLoading(false);
    return resp;
  };

  const descargar = async (nombre) => {
    const a = await descargarFoto(selected[0]?.NombreCompleto);
    downloadFile(a, nombre);
  };

  const eliminar = async () => {
    const resp = await eliminarFotos(selected?.NombreCompleto, eliminarFoto);
    toastShow(toast, "success", "Eliminado", "Foto eliminada correctamente.");
    setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== eliminarFoto));
    setShowDialogEliminar(false)
    setEliminarFoto([])
    setImagenes([])
  }

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Aspirantes", config.language));
    getInfo();
  }, []);

  return (
    <div
    className=" p-fluid px-4"
    style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "Aspirantes", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected([]);
              }}
            />
          </div>
        }
        contenido={
            <div style={{ height: '83vh' }} className="mt-4">
                <AgGrid table={table} />
            </div>
        }
      />

      
      {showDialog && (
        <CandidatosCRUD
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          modo={selected?.length > 0  ? "Editar" : "Crear"}
        />
      )}

      {showDialogFoto && (
        <ImagenCRUD
          fileUpload={fileUpload}
          showDialogFoto={showDialogFoto}
          setShowDialogFoto={setShowDialogFoto}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          subirArchivo={subirArchivo}
          getArchivos={getArchivos}
          descargar={descargar}
          eliminar={eliminar}
          showDialogEliminar={showDialogEliminar}
          setShowDialogEliminar={setShowDialogEliminar}
          setEliminarFoto={setEliminarFoto}
          loading={loading}
          imagenes={imagenes}
          listadoArchivos={listadoArchivos}
          title={`Agregar Foto -  ${selected[0]?.NombreCompleto}`}
        />
      )}
    </div>
  );
};

export default CandidatosScreen;
